import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileSmall = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "-8 -8 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.5 0H3.5C2.6 0 2 0.6 2 1.5V22.5C2 23.4 2.6 24 3.5 24H15.5L23 16.5V1.5C23 0.6 22.4 0 21.5 0ZM5 3H20V15H14V21H5V3Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgFileSmall);
export default ForwardRef;
